// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gFnRy","colMin":"styles_colMin__4XRv0"};